import React, { useContext, useCallback, useMemo, MouseEvent } from 'react'

import EditorContext from '../EditorContext'

import {
  ContentState,
  ContentBlock,
  convertFromRaw,
} from 'draft-js'

import {
  flattenLink,
} from '@kaidam/fc-shared/src/texteditor/utils'

import {
  ITextEditor_Entity_Link,
} from '@kaidam/fc-shared/src/types/texteditor'

import {
  TEXT_EDITOR_LINK_TARGET_SELF,
  TEXT_EDITOR_ENTITY_TYPE_LINK,
} from '@kaidam/fc-shared/src/constants'

const strategy = (
  contentBlock: ContentBlock,
  callback: {
    (start: number, end: number): void,
  },
  contentState: ContentState,
) => {
  contentBlock.findEntityRanges(
    (character) => {
      const entityKey = character.getEntity()
      return (
        entityKey !== null &&
        contentState.getEntity(entityKey).getType() === TEXT_EDITOR_ENTITY_TYPE_LINK
      )
    },
    callback
  )
}

const component = (props: any) => {

  const editorContext = useContext(EditorContext)
  const entity = props.contentState.getEntity(props.entityKey).getData() as ITextEditor_Entity_Link
  const url = entity.url
  const target = entity.target || TEXT_EDITOR_LINK_TARGET_SELF

  const textUrl = useMemo<string>(() => {
    return flattenLink(entity)
  }, [
    entity,
  ])

  const onClick = useCallback((e: MouseEvent) => {
    if(!editorContext.disableLinkClicks) return
    e.preventDefault()
    e.stopPropagation()
    return false
  }, [
    editorContext.disableLinkClicks,
  ])

  return (
    <a
      href={ textUrl }
      target={`_${target}`}
      style={{textDecoration: 'underline'}}
      onClick={ onClick }
    >
      {props.children}
    </a>
  )
}

const linkDecorator = {
  strategy,
  component,
}

export default linkDecorator